import { render } from "./SafeDrivingCard.vue?vue&type=template&id=0a1f23fc&scoped=true"
import script from "./SafeDrivingCard.vue?vue&type=script&lang=js"
export * from "./SafeDrivingCard.vue?vue&type=script&lang=js"

import "./SafeDrivingCard.vue?vue&type=style&index=0&id=0a1f23fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a1f23fc"]])

export default __exports__